export function extractApiError(body: unknown, fallback: string): string {
  if (typeof body !== 'object' || body === null) return fallback;
  const record = body as Record<string, unknown>;
  const err = record['error'];
  if (typeof err === 'string') return err;
  if (typeof err === 'object' && err !== null) {
    const errRecord = err as Record<string, unknown>;
    const msg = errRecord['message'];
    if (typeof msg === 'string') {
      try {
        const issues = JSON.parse(msg) as Array<{ message: string }>;
        const first = issues[0]?.message;
        if (first) return first;
      } catch {
        return msg;
      }
    }
  }
  // Handle { message: "..." } shape (common Hono error format)
  const message = record['message'];
  if (typeof message === 'string') return message;
  return fallback;
}
